import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MaterialModule } from 'src/app/material/material.module';
import { PanelMemberListComponent } from './panel-member-list/panel-member-list.component';
import { PanelMemberComponent } from './panel-member.component';
import { AppComponent } from 'src/app/app.component';
import { UploadExcelComponent } from './upload-excel/upload-excel.component';
import { NotificationService } from '../../shared/notification.service';


@NgModule({
  declarations: [
    PanelMemberComponent,
    PanelMemberListComponent,
    UploadExcelComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  bootstrap: [
    AppComponent
  ],
  providers: [
    NotificationService
  ],
  entryComponents: [PanelMemberComponent, UploadExcelComponent]

})
export class PanelMemberModule {}
